// resources/js/composables/useAuth.js
import { useSessionAuth } from './useSessionAuth'

// This is a simple wrapper to maintain compatibility with existing code
export function useAuth() {
  const {
    getUser,
    getAbilities, 
    getStores,
    getSelectedStore,
    fetchUserData,
    isAuthenticated,
    clearAuth,
    userData,
    userAbilities,
    stores,
    selectedStore,
    isLoading,
  } = useSessionAuth()

  // Computed-like getters for compatibility
  const user = () => getUser()
  const abilities = () => getAbilities()
  const userStores = () => getStores()
  const currentStore = () => getSelectedStore()

  // Legacy compatibility - return data in localStorage-like format
  const getUserData = () => {
    const user = getUser()
    if (!user) return null
    
    return {
      id: user.id,
      email: user.email,
      firstname: user.firstname,
      lastname: user.lastname,
      username: user.username,
      phone: user.phone,
      role: user.role,
      permissions: getAbilities(),
      stores: getStores(),
      selectedStore: getSelectedStore(),
      StoreID: user.StoreID,
      StoreName: user.StoreName,
      StoreSelected: user.StoreSelected,
      TabernaAccountID: user.TabernaAccountID,
    }
  }

  // Check if user has specific permission
  const hasPermission = permission => {
    const abilities = getAbilities()
    
    return abilities.includes(permission)
  }

  // Check if user has specific role
  const hasRole = role => {
    const user = getUser()
    
    return user?.role?.name === role
  }

  return {
    // Data getters
    user,
    abilities,
    userStores,
    currentStore,
    getUserData,
    
    // Actions
    fetchUserData,
    isAuthenticated,
    clearAuth,
    hasPermission,
    hasRole,
    
    // Reactive refs
    userData,
    userAbilities,
    stores,
    selectedStore,
    isLoading,
  }
}
